import { Color4 as BABYLON_Color4 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.color.js';
import { Vector3 as BABYLON_Vector3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
export function ivec3_to_col4(col, alpha = 1.0) {
    return new BABYLON_Color4(col.x, col.y, col.z, alpha);
}
export function icolor_to_col4(col, alpha = 1.0) {
    return new BABYLON_Color4(col.r, col.g, col.b, alpha);
}
export function vector_3(vec3) {
    return new BABYLON_Vector3(vec3.x, vec3.y, vec3.z);
}
//# sourceMappingURL=Conversion.js.map